<template>

    <v-radio-group class="compact" outlined 
        :value="value" :mandatory="false" :label="schema.label"
        @change="$emit('change', $event)"
    >
        <v-radio v-for="(item, index) in schema.items" :label="item.text" :value="item.value" :key="index"></v-radio>
    </v-radio-group>

</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// RadioControl.vue?79502080